import { render, staticRenderFns } from "./TableDragSelect.vue?vue&type=template&id=5db20efb&"
import script from "./TableDragSelect.js?vue&type=script&lang=js&"
export * from "./TableDragSelect.js?vue&type=script&lang=js&"
import style0 from "./TableDragSelect.vue?vue&type=style&index=0&id=5db20efb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports